import { styled } from '@mui/styles';
import { Stack } from '@mui/material';

export const Portal = styled(Stack)({
  boxShadow: 'rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,  rgba(0, 0, 0, 0.1) 0px 1px 2px -1px',
  borderRadius: '4px',
  border: '1px solid #e5e7eb',
})
